export default "__VITE_ASSET__CFaXBexx__"